






























import { Component, Prop } from "vue-property-decorator";
import { Getter, Action, State } from "vuex-class";
import { mixins } from "vue-class-component";
import LoadingMixin from "@/mixins/LoadingMixin";
import ContentMixin from "@/mixins/ContentMixin";
import { IContentSection } from "@/store/modules/content/types";
import { Route, NavigationGuardNext } from "vue-router";

const namespace: string = "practiceModule";

Component.registerHooks(["beforeRouteLeave", "beforeRouteEnter"]);

@Component({
  name: "practice-wait",
})
export default class PracticeWait extends mixins(LoadingMixin, ContentMixin) {
  @Action("takeSection", { namespace })
  public takeSection!: (subject: string) => Promise<void>;

  @Action("fetchContentQuestions", { namespace })
  public fetchContentQuestions!: (section_id: number) => Promise<void>;

  @Action("fetchContentPassages", { namespace })
  public fetchContentPassages!: (section_id: number) => Promise<void>;

  @Action("previous", { namespace })
  public previous!: (remainingTime: number) => Promise<void>;

  @State("section", { namespace })
  public section!: IContentSection;

  @Getter("nextSection", { namespace })
  public firstSection!: string;

  //@Prop({ default: null })
  //public subject!: string;

  public subject = "ela";

  public goto = "/practice/assessment/ela";

  public async beforeRouteEnter(
    to: Route,
    from: Route,
    next: NavigationGuardNext<PracticeWait>
  ) {
    next(async vm => {
      await vm.load();
    });
  }

  private async load() {
    this.$Progress.start();
    try {
      this.isLoading = true;

      //await this.takeSection(this.subject);
      this.$Progress.finish();
    } catch (e) {
      this.isLoading = false;
      this.$Progress.fail();
      throw e;
    } finally {
      this.isLoading = false;
    }
  }

  public async onStartSection() {
    await this.$router.push("/practice/assessment/" + this.firstSection);
  }
}
